import React, {
	useEffect,
	useState,
	Fragment as Frag
} from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import {
	makeStyles
} from '@material-ui/core';

import {useSelectedSubNavTab} from "../utils/CustomHooks";
import Constants from "../utils/Constants";
import PatternsTabs from "../components/PatternsTabs";
import SubNavPanelsWrapper from "../components/SubNavPanelsWrapper";
import PatternsList from "../containers/PatternsList";
import PatternDetails from "../containers/PatternDetails";

const styles = makeStyles(theme => ({
	fullScreenClassName: {
		[theme.breakpoints.only('md')]: {
			paddingTop: `${theme.spacing(28.125)}px !important`
		}
	}
}));

function Patterns(props) {
	const [selectedTab, setSelectedTab] = useState(false);

	const tabs = [Constants.PATTERN.STATUSES.ACTIVE, Constants.PATTERN.STATUSES.INACTIVE];

	let classes = styles(),
		{history, location, updateHeader, resetHeader,
			setFullScreenClassName, setBannerClassName, showSnackbar, hasNudgeBanner} = props,
		fullScreenClassName = classes.fullScreenClassName;

	const getSelectedTab = useSelectedSubNavTab(location, tabs);

	// TODO: is there a way to NOT do this in the case of edit?
	useEffect(() => {
		updateHeader({title: "patterns", primary: true});
		return () => resetHeader();
	}, [updateHeader, resetHeader]);

	useEffect(() => {
		setSelectedTab(getSelectedTab());
	}, [getSelectedTab, setSelectedTab]);

	useEffect(() => {
		setFullScreenClassName(fullScreenClassName);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const tabClicked = (event, tab) => {
		setSelectedTab(tab);
		history.push(`/patterns/${tab}`);
	};

	return (
		<Frag>
			<PatternsTabs
				selectedTab={selectedTab}
				tabClicked={tabClicked}
				hasNudgeBanner={hasNudgeBanner}
				setBannerClassName={setBannerClassName} />
			<SubNavPanelsWrapper>
				<Switch>
					<Route
						path="/patterns/:status/:patternId"
						render={(renderProps) => (
							<PatternDetails
								history={history}
								patternId={renderProps.match.params.patternId}
								status={renderProps.match.params.status}
								updateHeader={updateHeader}
								resetHeader={resetHeader}
								showSnackbar={showSnackbar}
								setFullScreenClassName={setFullScreenClassName} />
						)} />

					<Route
						path="/patterns/:status"
						render={(renderProps) => (
							<PatternsList
								history={history}
								showSnackbar={showSnackbar}
								status={renderProps.match.params.status} />
						)} />
				</Switch>
			</SubNavPanelsWrapper>
		</Frag>
	);
}

Patterns.propTypes = {
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired,
	setBannerClassName: PropTypes.func.isRequired,
	hasNudgeBanner: PropTypes.bool,
	setFullScreenClassName: PropTypes.func
};

export default Patterns;